import { AxiosResponse, AxiosRequestConfig } from 'axios'
import * as qs from 'query-string'

import { accidentsApi } from './'

import { File } from '../interfaces/File.interface'
import { Claim } from '../interfaces/Claim.interface'
import { Accident } from '../interfaces/Accident.interface'
import { ClaimArea } from '../interfaces/ClaimArea.interface'
import { AccidentType } from '../interfaces/AccidentType.interface'
import { CountSummary } from '../interfaces/CountSummary.interface'
import { AccidentStatus } from '../interfaces/AccidentStatus.interface'
import { AccidentComment } from '../interfaces/AccidentComment.interface'

export type AccidentListResponse = Accident[]

export type FetchAccidentsQuery = {
  location?: number[]
  position?: number[]
  fromDate?: string
  toDate?: string
  sort?: string
  order?: string
  status?: number[]
  type?: number[]
  approval?: string[]
}

export const upsertAccident = (accident: Accident) => {
  let promise
  if (accident.id) {
    promise = accidentsApi.put<Accident>(`/accident/${accident.id}`, accident)
  }
  else {
    promise = accidentsApi.post<Accident>('/accident', accident)
  }

  return promise
    .then((response: AxiosResponse) => response.data)
}

export const upsertClaim = (claim: Claim) => {
  let promise
  if (claim.id) {
    promise = accidentsApi.put<Claim>(`/claim/${claim.id}`, claim)
  }
  else {
    promise = accidentsApi.post<Claim>('/claim', claim)
  }

  return promise
    .then((response: AxiosResponse) => response.data)
}

export const getAccidents = (params?: FetchAccidentsQuery) => {
  const axiosConfig: AxiosRequestConfig = {
    params,
    paramsSerializer: p => qs.stringify(p)
  }

  return accidentsApi.get<AccidentListResponse>('/accident', axiosConfig)
    .then((response: AxiosResponse) => response.data)
}

export const getAccident = (accidentId: string|number) => {
  return accidentsApi.get<Accident>(`/accident/${accidentId}`)
    .then((response: AxiosResponse) => response.data)
}

// export const getAccidentHistogram = (params?: FetchAccidentsQuery) => {
//   const axiosConfig: AxiosRequestConfig = {
//     params,
//     paramsSerializer: p => qs.stringify(p)
//   }

//   return api.get<[string, number]>('/api/claim/histogram', axiosConfig)
//     .then((response: AxiosResponse) => response.data)
// }

export const getAccidentsSummary = (params?: FetchAccidentsQuery) => {
  const axiosConfig: AxiosRequestConfig = {
    params,
    paramsSerializer: p => qs.stringify(p)
  }

  return accidentsApi.get<[string, number]>('/accident/summary', axiosConfig)
    .then((response: AxiosResponse) => response.data)
}

export const getAccidentsPendingStatusCount = () => {
  return accidentsApi.get<CountSummary>('/accident/metrics/pending')
    .then((response: AxiosResponse) => response.data)
}

export const getAccidentTypes = () => {
  return accidentsApi.get<AccidentType>('/claim/type')
    .then((response: AxiosResponse) => response.data)
}

export const getAccidentStatus = () => {
  return accidentsApi.get<AccidentStatus>('/claim/status')
    .then((response: AxiosResponse) => response.data)
}

export const getClaim = (claimId: number) => {
  return accidentsApi.get<Claim>(`/claim/${claimId}`)
    .then((response: AxiosResponse) => response.data)
}

export const getOpenClaims = () => {
  return accidentsApi.get<Claim>('/claim/open')
    .then((response: AxiosResponse) => response.data)
}

export const getClaimAreas = () => {
  return accidentsApi.get<ClaimArea>('/claim/area')
    .then((response: AxiosResponse) => response.data)
}

export const getAccidentFiles = (accidentId: number) => {
  return accidentsApi.get<File>(`/accident/${accidentId}/files`)
    .then((response: AxiosResponse) => response.data)
}

export const postAccidentComment = (accidentId: string, comment: string) => {
  return accidentsApi.post<AccidentComment>(`/accident/${accidentId}/comment`, { comment })
    .then((response: AxiosResponse) => response.data)
}

export const uploadAccidentFile = (accidentId: number|string, file: any) => {
  const formData = new FormData()
  formData.append('file', file)

  return accidentsApi.post(`accident/${accidentId}/files`, formData)
    .then((response: AxiosResponse) => response.data)
}

export const searchClaims = (params: any) => {
  const axiosConfig: AxiosRequestConfig = {
    params,
    paramsSerializer: p => qs.stringify(p)
  }

  return accidentsApi.get<Claim>('/accident/claims/search', axiosConfig)
    .then((response: AxiosResponse) => response.data)
}

export const removeAccident = (accidentId: number|string) => {
  return accidentsApi.delete(`/accident/${accidentId}`)
}

export const removeClaim = (claimId: number|string) => {
  return accidentsApi.delete(`/claim/${claimId}`)
}

export const setAccidentManagerApproval = (accidentId: number|string, managerApproval: string) => {
  return accidentsApi.put(`/accident/${accidentId}/managerApproval`, { managerApproval })
    .then((response: AxiosResponse) => response.data)
}



// WEBPACK FOOTER //
// ./src/lib/api/accidents.ts